import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppRoutingModule } from '../app-routing.module';
import { ChartsModule } from 'ng2-charts';
import { NgxEditorModule } from 'ngx-editor';


import { DashboardComponent } from './dashboard/dashboard.component';
import { PagesComponent } from './pages.component';
import { CreateUserComponent } from './create-user/create-user.component';
import { UsersComponent } from './users/users.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { Pf16Component } from './16Pf/pf16/pf16.component';
import { CreatePf16Component } from './16Pf/create-pf16/create-pf16.component';
import { EditPf16Component } from './16Pf/edit-pf16/edit-pf16.component';
import { CreatePf16FactorComponent } from './16Pf/create-pf16-factor/create-pf16-factor.component';
import { EditPf16FactorComponent } from './16Pf/edit-pf16-factor/edit-pf16-factor.component';
import { ClientEvaluatedComponent } from './client-evaluated/client-evaluated.component';
import { CreateEvaluatedComponent } from './create-evaluated/create-evaluated.component';
import { RequestedTestsComponent } from './requested-tests/requested-tests.component';
import { CreateZavicComponent } from './zavic/create-zavic/create-zavic.component';
import { CreateZavicFactorComponent } from './zavic/create-zavic-factor/create-zavic-factor.component';
import { ViewZavicComponent } from './zavic/view-zavic/view-zavic.component';
import { ViewZavicFactorsComponent } from './zavic/view-zavic-factors/view-zavic-factors.component';
import { ZavicComponent } from './zavic/zavic/zavic.component';
import { CreateIpvComponent } from './ipv/create-ipv/create-ipv.component';
import { CreateIpvTypeComponent } from './ipv/create-ipv-type/create-ipv-type.component';
import { ViewIpvTypeComponent } from './ipv/view-ipv-type/view-ipv-type.component';
import { ViewIpvComponent } from './ipv/view-ipv/view-ipv.component';
import { IpvComponent } from './ipv/ipv/ipv.component';
import { AllPortComponent } from './all-port/all-port/all-port.component';
import { CreateAllPortComponent } from './all-port/create-all-port/create-all-port.component';
import { CreateAllPortFactorComponent } from './all-port/create-all-port-factor/create-all-port-factor.component';
import { ViewAllPortFactorComponent } from './all-port/view-all-port-factor/view-all-port-factor.component';
import { ViewAllPortComponent } from './all-port/view-all-port/view-all-port.component';
import { BarsicComponent } from './barsic/barsic/barsic.component';
import { CreateBarsicComponent } from './barsic/create-barsic/create-barsic.component';
import { CreateBarsicFactorComponent } from './barsic/create-barsic-factor/create-barsic-factor.component';
import { ViewBarsicFactorComponent } from './barsic/view-barsic-factor/view-barsic-factor.component';
import { ViewBarsicComponent } from './barsic/view-barsic/view-barsic.component';
import { CleaverComponent } from './cleaver/cleaver/cleaver.component';
import { CreateCleaverComponent } from './cleaver/create-cleaver/create-cleaver.component';
import { CreateCleaverFactorComponent } from './cleaver/create-cleaver-factor/create-cleaver-factor.component';
import { EditCleaverFactorComponent } from './cleaver/edit-cleaver-factor/edit-cleaver-factor.component';
import { EditCleaverComponent } from './cleaver/edit-cleaver/edit-cleaver.component';
import { TermanComponent } from './terman/terman/terman.component';
import { CreateTermanComponent } from './terman/create-terman/create-terman.component';
import { CreateTermanFactorComponent } from './terman/create-terman-factor/create-terman-factor.component';
import { ViewTermanFactorComponent } from './terman/view-terman-factor/view-terman-factor.component';
import { ViewTermanComponent } from './terman/view-terman/view-terman.component';
import { KostikComponent } from './kostik/kostik/kostik.component';
import { CreateKostikComponent } from './kostik/create-kostik/create-kostik.component';
import { ViewKostikComponent } from './kostik/view-kostik/view-kostik.component';
import { CreateKostikFactorComponent } from './kostik/create-kostik-factor/create-kostik-factor.component';
import { ViewKostikFactorComponent } from './kostik/view-kostik-factor/view-kostik-factor.component';
import { PaymentsComponent } from './payments/payments.component';
import { TextsComponent } from './texts/texts.component';
import { Pf16InterpretationComponent } from './16Pf/pf16-interpretation/pf16-interpretation.component';
import { PfTextsComponent } from './16Pf/pf-texts/pf-texts.component';
import { ZavicTextsComponent } from './zavic/zavic-texts/zavic-texts.component';
import { IpvTextsComponent } from './ipv/ipv-texts/ipv-texts.component';
import { AllPortTextsComponent } from './all-port/all-port-texts/all-port-texts.component';
import { BarsicTextsComponent } from './barsic/barsic-texts/barsic-texts.component';
import { CleaverTextsComponent } from './cleaver/cleaver-texts/cleaver-texts.component';
import { TermanTextsComponent } from './terman/terman-texts/terman-texts.component';
import { KostikTextsComponent } from './kostik/kostik-texts/kostik-texts.component';
import { SplitPipe } from './pipes/split.pipe';
import { SplitTabPipe } from './pipes/split-tab.pipe';
import { UsersPipe } from './pipes/users.pipe';
import { PlansComponent } from './plans/plans.component';
import { EditPlansComponent } from './edit-plans/edit-plans.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { InfoComponent } from './info/info.component';
import { CreateMmpi2FactorComponent } from './mmpi2/create-mmpi2-factor/create-mmpi2-factor.component';
import { Mmpi2InterpretationsComponent } from './mmpi2/mmpi2-interpretations/mmpi2-interpretations.component';
import { Mmpi2QuestionsComponent } from './mmpi2/mmpi2-questions/mmpi2-questions.component';
import { Mmpi2Component } from './mmpi2/mmpi2/mmpi2.component';
import { Mmpi2TextsComponent } from './mmpi2/mmpi2-texts/mmpi2-texts.component';
import { ScalePipePipe } from './pipes/scale-pipe.pipe';
import { NullPipePipe } from './pipes/null-pipe.pipe';
import { HtmlPipe } from './pipes/html.pipe';
import { Mmpi2CombinationsComponent } from './mmpi2/mmpi2-combinations/mmpi2-combinations.component';
import { AnswersPipe } from './pipes/answers.pipe';
import { CreateMmpiaFactorComponent } from './mmpia/create-mmpia-factor/create-mmpia-factor.component';
import { MmpiaComponent } from './mmpia/mmpia/mmpia.component';
import { MmpiaCombinationsComponent } from './mmpia/mmpia-combinations/mmpia-combinations.component';
import { MmpiaInterpretationsComponent } from './mmpia/mmpia-interpretations/mmpia-interpretations.component';
import { MmpiaQuestionsComponent } from './mmpia/mmpia-questions/mmpia-questions.component';
import { MmpiaTextsComponent } from './mmpia/mmpia-texts/mmpia-texts.component';
import { MfmPipe } from './pipes/mfm.pipe';
import { CreateScaleComponent } from './mips/create-scale/create-scale.component';
import { MipsComponent } from './mips/mips/mips.component';
import { MipsInterpretationsComponent } from './mips/mips-interpretations/mips-interpretations.component';
import { MipsQuestionsComponent } from './mips/mips-questions/mips-questions.component';
import { MipsTextsComponent } from './mips/mips-texts/mips-texts.component';
import { MipsScalePipe } from './pipes/mips-scale-pipe';
import { ScaleMmpiaPipe } from './pipes/scale-mmpia.pipe';
import { Bis11Component } from './bis11/bis11/bis11.component';
import { Bis11TextsComponent } from './bis11/bis11-texts/bis11-texts.component';
import { Bis11QuestionsComponent } from './bis11/bis11-questions/bis11-questions.component';
import { Bis11InterpretationComponent } from './bis11/bis11-interpretation/bis11-interpretation.component';
import { ChasideQuestionsComponent } from './chaside/chaside-questions/chaside-questions.component';
import { ChasideInterpretationsComponent } from './chaside/chaside-interpretations/chaside-interpretations.component';
import { ChasideTextsComponent } from './chaside/chaside-texts/chaside-texts.component';
import { ChasideComponent } from './chaside/chaside/chaside.component';
import { CameraComponent } from './camera/camera.component';
import { LoaderComponent } from './loader/loader.component';
import { LeveWidgetComponent } from './leve-widget/leve-widget.component';
import { DominoComponent } from './domino/domino/domino.component';
import { DominoTextsComponent } from './domino/domino-texts/domino-texts.component';
import { CreateFactorsComponent } from './domino/create-factors/create-factors.component';
import { ComponentsModule } from '../components/components.module';
import { TestFilterPipe } from './pipes/test-filter.pipe';
import { PaginatorFilterPipe } from './pipes/paginator-filter.pipe';
import { FullPageLoaderComponent } from './full-page-loader/full-page-loader.component';
import { IsFormFilterPipe } from './is-form-filter.pipe';
import { FormsComponent } from './forms/forms.component';
import { MassiveFilterPipe } from './massive-filter.pipe';
import { FormFilterPipe } from './form-filter.pipe';
import { CustomTestsComponent } from './custom-tests/custom-tests.component';
import { CreateCustomTestsComponent } from './create-custom-tests/create-custom-tests.component';
import { TestGroupsComponent } from './test-groups/test-groups.component';
import { CreateTestGroupComponent } from './create-test-group/create-test-group.component';
import { QuestionTypePipe } from './pipes/question-type.pipe';
import { NumberToLetterPipe } from './pipes/number-to-letter.pipe';
import { TestGroupPipe } from './pipes/test-group.pipe';
import { CustomFormComponent } from './custom-form/custom-form.component';
import { QuillToHtmlPipe } from './pipes/quill-to-html.pipe';
import { CustomTestReportComponent } from './custom-test-report/custom-test-report.component';
import { GroupsInfoComponent } from './groups-info/groups-info.component';
import { CustomTestHistoryComponent } from './custom-test-history/custom-test-history.component';
import { SubaccountsComponent } from './subaccounts/subaccounts.component';
import { FolderPipe } from './pipes/folder.pipe';
import { CleaverGlossaryPipe } from './pipes/cleaver-glossary.pipe';
import { CleaverHfFormComponent } from './components/cleaver-hf-form/cleaver-hf-form.component';
import { HumanFactorTextsComponent } from './cleaver/human-factor-texts/human-factor-texts.component';
import { ProfileCompletePercentComponent } from './components/profile-complete-percent/profile-complete-percent.component';
import { EmailTextsComponent } from './email-texts/email-texts.component';
import { TestInfoComponent } from './test-info/test-info.component';
import { PaymentTypePipe } from './pipes/payment-type.pipe';
import { SearchUserPipe } from './pipes/search-user.pipe';


@NgModule({
  declarations: [
    DashboardComponent,
    PagesComponent,
    CreateUserComponent,
    UsersComponent,
    EditUserComponent,
    Pf16Component,
    CreatePf16Component,
    EditPf16Component,
    CreatePf16FactorComponent,
    EditPf16FactorComponent,
    ClientEvaluatedComponent,
    CreateEvaluatedComponent,
    RequestedTestsComponent,
    CreateZavicComponent,
    CreateZavicFactorComponent,
    ViewZavicComponent,
    ViewZavicFactorsComponent,
    ZavicComponent,
    CreateIpvComponent,
    CreateIpvTypeComponent,
    ViewIpvTypeComponent,
    ViewIpvComponent,
    IpvComponent,
    AllPortComponent,
    CreateAllPortComponent,
    CreateAllPortFactorComponent,
    ViewAllPortFactorComponent,
    ViewAllPortComponent,
    BarsicComponent,
    CreateBarsicComponent,
    CreateBarsicFactorComponent,
    ViewBarsicFactorComponent,
    ViewBarsicComponent,
    CleaverComponent,
    CreateCleaverComponent,
    CreateCleaverFactorComponent,
    EditCleaverFactorComponent,
    EditCleaverComponent,
    TermanComponent,
    CreateTermanComponent,
    CreateTermanFactorComponent,
    ViewTermanFactorComponent,
    ViewTermanComponent,
    KostikComponent,
    CreateKostikComponent,
    ViewKostikComponent,
    CreateKostikFactorComponent,
    ViewKostikFactorComponent,
    PaymentsComponent,
    TextsComponent,
    Pf16InterpretationComponent,
    PfTextsComponent,
    ZavicTextsComponent,
    IpvTextsComponent,
    AllPortTextsComponent,
    BarsicTextsComponent,
    CleaverTextsComponent,
    TermanTextsComponent,
    KostikTextsComponent,
    SplitPipe,
    SplitTabPipe,
    UsersPipe,
    PlansComponent,
    EditPlansComponent,
    MyAccountComponent,
    InfoComponent,
    CreateMmpi2FactorComponent,
    Mmpi2InterpretationsComponent,
    Mmpi2QuestionsComponent,
    Mmpi2Component,
    Mmpi2TextsComponent,
    ScalePipePipe,
    NullPipePipe,
    HtmlPipe,
    Mmpi2CombinationsComponent,
    AnswersPipe,
    CreateMmpiaFactorComponent,
    MmpiaComponent,
    MmpiaCombinationsComponent,
    MmpiaInterpretationsComponent,
    MmpiaQuestionsComponent,
    MmpiaTextsComponent,
    MfmPipe,
    CreateScaleComponent,
    MipsComponent,
    MipsInterpretationsComponent,
    MipsQuestionsComponent,
    MipsTextsComponent,
    MipsScalePipe,
    ScaleMmpiaPipe,
    Bis11Component,
    Bis11TextsComponent,
    Bis11QuestionsComponent,
    Bis11InterpretationComponent,
    ChasideQuestionsComponent,
    ChasideInterpretationsComponent,
    ChasideTextsComponent,
    ChasideComponent,
    CameraComponent,
    LoaderComponent,
    LeveWidgetComponent,
    DominoComponent,
    DominoTextsComponent,
    CreateFactorsComponent,
    TestFilterPipe,
    PaginatorFilterPipe,
    FullPageLoaderComponent,
    IsFormFilterPipe,
    FormsComponent,
    MassiveFilterPipe,
    FormFilterPipe,
    CustomTestsComponent,
    CreateCustomTestsComponent,
    TestGroupsComponent,
    CreateTestGroupComponent,
    QuestionTypePipe,
    NumberToLetterPipe,
    TestGroupPipe,
    CustomFormComponent,
    QuillToHtmlPipe,
    CustomTestReportComponent,
    GroupsInfoComponent,
    CustomTestHistoryComponent,
    SubaccountsComponent,
    FolderPipe,
    CleaverGlossaryPipe,
    CleaverHfFormComponent,
    HumanFactorTextsComponent,
    ProfileCompletePercentComponent,
    EmailTextsComponent,
    TestInfoComponent,
    PaymentTypePipe,
    SearchUserPipe,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    ChartsModule,
    NgxEditorModule,
    ComponentsModule,
  ],
  exports: [
    PagesComponent,
    DashboardComponent
  ],
  providers: [
    DatePipe,
    FolderPipe,
    TestFilterPipe,
    
  ]
})
export class PagesModule { }
